import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatColors } from '@fuse/mat-colors';
import { EmployeeCalendarEventModel } from '../event.model';
var EmployeeCalendarEventFormDialogComponent = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {MatDialogRef<EmployeeCalendarEventFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    function EmployeeCalendarEventFormDialogComponent(matDialogRef, _data, _formBuilder) {
        this.matDialogRef = matDialogRef;
        this._data = _data;
        this._formBuilder = _formBuilder;
        this.presetColors = MatColors.presets;
        this.event = _data.event;
        this.action = _data.action;
        this.eventTypes = _data.types;
        this.company = _data.company;
        console.log(this.eventForm, this.eventTypes);
        if (this.action === 'edit') {
            this.dialogTitle = this.event.title;
        }
        else {
            this.dialogTitle = 'Add non working day/days';
            this.event = new EmployeeCalendarEventModel({
                start: _data.date,
                end: _data.date
            });
        }
        this.eventForm = this.createEventForm();
    }
    Object.defineProperty(EmployeeCalendarEventFormDialogComponent.prototype, "f", {
        // -----------------------------------------------------------------------------------------------------
        // @ Public methods
        // -----------------------------------------------------------------------------------------------------
        // convenience getter for easy access to form fields
        get: function () { return this.eventForm.controls; },
        enumerable: true,
        configurable: true
    });
    EmployeeCalendarEventFormDialogComponent.prototype.getGroup = function (type) {
        var _this = this;
        var retVal = '';
        Object.keys(this.eventTypes).forEach(function (group) {
            if (_this.eventTypes[group].indexOf(type) > -1) {
                retVal = group;
            }
        });
        return retVal;
    };
    EmployeeCalendarEventFormDialogComponent.prototype.nextDay = function () {
        var date = new Date(this.eventForm.get('start').value);
        return new Date(date.setDate(date.getDate() + 1));
    };
    /**
     * Create the event form
     *
     * @returns {FormGroup}
     */
    EmployeeCalendarEventFormDialogComponent.prototype.createEventForm = function () {
        return new FormGroup({
            id: new FormControl(this.event.id),
            type: new FormControl(this.event.type),
            typeGroup: new FormControl(''),
            title: new FormControl(this.event.title),
            start: new FormControl(this.event.start),
            end: new FormControl(this.event.end),
            days: new FormControl(this.event.days),
            isRecurring: new FormControl(this.event.isRecurring),
            frequenceTypeOfRecurring: new FormControl(this.event.frequenceTypeOfRecurring || 'day'),
            endOfRecurring: new FormControl(this.event.endOfRecurring || null),
        });
    };
    return EmployeeCalendarEventFormDialogComponent;
}());
export { EmployeeCalendarEventFormDialogComponent };
